import React, { Component, useEffect } from 'react';
import { useAppShell } from '../app-shell';
import { connect, ConnectedProps } from 'react-redux';
import { withStyles, WithStyles } from '@mui/styles';
import type { Theme } from '@mui/material/styles';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import GetAppIcon from '@mui/icons-material/GetApp';

import type { RootState } from '../../store';

interface GroupData {
  name?: string;
}

interface State {
  loading: boolean;
  group: GroupData | null;
  error: unknown;
}

const mapStateToProps = (state: RootState) => ({
  currentUser: state.auth.currentUser,
});

function mapDispatchToProps() {
  return {};
}

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto' as const,
    justifyContent: 'center',
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & WithStyles<typeof styles>;

class GroupPage extends Component<Props, State> {
  override state: State = {
    loading: false,
    group: null,
    error: null,
  };

  fetchData(): void {
    // Here is where we'd load the group to display the name
  }

  override componentDidMount(): void {
    this.fetchData();
  }

  override render(): React.JSX.Element {
    const { classes } = this.props;

    let groupContent: React.JSX.Element;
    if (this.state.group) {
      groupContent = (
        <div>
          <h2>{this.state.group.name}</h2>
          <p>
            It looks like someone invited you to the group{' '}
            <b>{this.state.group as unknown as string}.</b>
          </p>
        </div>
      );
    } else {
      groupContent = (
        <div>
          <p>It looks like someone invited you to a friend group on STASH.</p>
        </div>
      );
    }

    return (
      <div style={{ overflowX: 'auto', justifyContent: 'center' }}>
        <Paper className={classes.root}>
          <h1>STASH Friend Group</h1>
          <img
            src="/stash-screens-1.jpg"
            style={{ float: 'left', border: '1px solid #CCF0FF', margin: '10px' }}
            alt="STASH screens"
          />

          <Typography variant="body1" color="textPrimary" align="center">
            <h3>Welcome to STASH!</h3>
            {this.state.loading && 'Fetching Group...'}
            {!!this.state.error && 'ERROR'}
            {groupContent}
            <div style={{ padding: '20px' }}>
              <p>To see the full details, please</p>
              <Button
                size="large"
                variant="contained"
                color="primary"
                endIcon={<GetAppIcon />}
                target="_blank"
                href="https://apps.apple.com/us/app/stash-social/id1595856058"
              >
                Install the STASH Social App
              </Button>
            </div>
          </Typography>
        </Paper>
      </div>
    );
  }
}

const GroupPageWithStyles = withStyles(styles)(GroupPage);
const GroupPageConnected = (props: PropsFromRedux): React.JSX.Element => {
  const { setBreadcrumb } = useAppShell();
  useEffect(() => {
    setBreadcrumb(['Group']);
    return () => setBreadcrumb([]);
  }, [setBreadcrumb]);
  return <GroupPageWithStyles {...props} />;
};
export default connector(GroupPageConnected);
